import * as angular from 'angular';
import { config, reactShell } from 'angular/utils/config';

type DirectFcfsAccess = {
    roles: ('SHIPPER_USER' | 'TSO_USER')[];
    organisationId: string;
    assignedTsoIds: string[];
};

export class DirectFcfsAccessibleService {
    private directFcfsAccessible?: DirectFcfsAccess;

    constructor() {
        this.init();
    }

    private async init() {
        if (!config.directFcfs) return;
        try {
            const response = await reactShell.axios.request({
                url: `${config.directFcfs}/entrypoint`
            });
            this.directFcfsAccessible = response.data;
        } catch (e) {
            if (
                e &&
                e.name === 'AxiosError' &&
                e.response &&
                (e.response.status === 401 || e.response.status === 403)
            )
                return;
            console.error(e);
        }
    }

    get getDirectFcfsAccess() {
        return this.directFcfsAccessible;
    }
}

angular
    .module('app')
    .service('directFcfsAccessibleService', DirectFcfsAccessibleService);
